import { createAction, props } from '@ngrx/store';
import { ICostCentersState, TCostCenters } from './costCenters.state';

export enum CostCentersActions {
  CostCentersRequested = '[CostCenters] CostCenters Requested',
  CostCentersLoaded = '[CostCenters] CostCenters Loaded',
  CostCentersError = '[CostCenters] CostCenters Error',
  CostCentersLoading = '[CostCenters] CostCenters Loading',
}

export const CostCentersRequested = createAction(CostCentersActions.CostCentersRequested);

export const CostCentersLoading = createAction(CostCentersActions.CostCentersLoading);

export const CostCentersLoaded = createAction(CostCentersActions.CostCentersLoaded, props<{ costCenters: TCostCenters[] }>());

export const CostCentersError = createAction(CostCentersActions.CostCentersError);
